<template>
  <v-row class="pt-5">
    <v-col cols="12">
      <h2 class="headline mb-4 purple--text text--lighten-2">Competition</h2>
    </v-col>
    <v-col cols="12">
      <p class="purple--text text--lighten-4">Direct competitors</p>
      <v-row>
        <v-col cols="6" v-for="(tag, index) in doc.list1" :key="`q1-${index}`">
          <v-card light>
            <v-card-title>{{ tag.title }}</v-card-title>
            <v-card-text>
              <p class="pb-0 mb-0 black--text">What are they doing?</p>
              <p class="pb-0 mb-2">{{ tag.what }}</p>
              <p class="pb-0 mb-0 black--text">What can we learn from them?</p>
              <p class="pb-0 mb-2">{{ tag.learn }}</p>
              <p class="pb-0 mb-0 black--text">What do you do differently?</p>
              <p class="pb-0 mb-2">{{ tag.difference }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <p class="purple--text text--lighten-4">Indirect competitors</p>
      <v-row>
        <v-col cols="6" v-for="(tag, index) in doc.list2" :key="`q2-${index}`">
          <v-card light>
            <v-card-title>{{ tag.title }}</v-card-title>
            <v-card-text>
              <p class="pb-0 mb-0 black--text">What are they doing?</p>
              <p class="pb-0 mb-2">{{ tag.what }}</p>
              <p class="pb-0 mb-0 black--text">What can we learn from them?</p>
              <p class="pb-0 mb-2">{{ tag.learn }}</p>
              <p class="pb-0 mb-0 black--text">What do you do differently?</p>
              <p class="pb-0 mb-2">{{ tag.difference }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <p class="purple--text text--lighten-4">Comparators</p>
      <v-row>
        <v-col cols="6" v-for="(tag, index) in doc.list3" :key="`q3-${index}`">
          <v-card light>
            <v-card-title>{{ tag.title }}</v-card-title>
            <v-card-text>
              <p class="pb-0 mb-0 black--text">What are they doing?</p>
              <p class="pb-0 mb-2">{{ tag.what }}</p>
              <p class="pb-0 mb-0 black--text">What can we learn from them?</p>
              <p class="pb-0 mb-2">{{ tag.learn }}</p>
              <p class="pb-0 mb-0 black--text">What do you do differently?</p>
              <p class="pb-0 mb-2">{{ tag.difference }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsCompetition",
  data() {
    return {
      items: null,
      doc: null,
      admins: null,
      results: {
        q1: [],
        q2: [],
        q3: [],
        q4: [],
        q5: [],
        q6: [],
        q7: [],
        q8: [],
      },
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getExercise();
        }
      },
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  mounted() {},
  methods: {
    getExercise() {
      this.doc = null;
      let ref = fb.fourCornersCompetitionExCollection.where(
        "pid",
        "==",
        this.id
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            console.log("items", items);
            this.doc = items[0].doc;
          }
        })
        .catch(function() {});
    },

    getResults(doc) {
      this.pushToArray(doc.matrix.q1, "q1");
      this.pushToArray(doc.matrix.q2, "q2");
      this.pushToArray(doc.matrix.q3, "q3");
      this.pushToArray(doc.matrix.q4, "q4");
      this.pushToArray(doc.matrix.q5, "q5");
      this.pushToArray(doc.matrix.q6, "q6");
      this.pushToArray(doc.matrix.q7, "q7");
      this.pushToArray(doc.matrix.q8, "q8");
    },
    pushToArray(arr, model) {
      if (arr || arr.length > 0 || arr != undefined) {
        console.log(arr);
        arr.forEach((y) => {
          this.results[model].push(y);
        });
      }
    },
  },
};
</script>
